(function() {
'use strict';

angular
    .module('TR')
    .controller('MarhabaAvailability', MarhabaAvailability);

function MarhabaAvailability($scope, $rootScope, marhabaSearch, $routeParams, $location, tripService, resourceService, analytics) {
    const cm = this;

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        const searchId = trip.MarhabaRequest.AvailabilitySearchId;

        analytics.track('mixpanel', 'MarhabaPage');

        cm.header = {};
        cm.loaded = false;
        cm.selectProduct = undefined;

        $rootScope.lockScreen($scope, {
            title: resourceService.get('MARHABASEARCHING'),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: 'default-marhabaAvailabilityCtrl'
        });

        marhabaSearch.getSearchResults(searchId, trip).then(function(res) {
            cm.lounges = [];
            cm.meetGreet = [];
            cm.transfers = [];

            function _categorize(p, index) {
                if (p.AdultPrice === 0) {
                    return;
                }
                switch (p.Type) {
                    case 1:
                        cm.meetGreet.push(p);
                        break;

                    case 5:
                        cm.lounges.push(p);
                        break;

                    case 2:
                        cm.transfers.push(p);
                }
                cm.loaded = index === res.MarhabaQuotes.length - 1;
            }

            function _order(a, b) {
                if (a.TotalPrice > b.TotalPrice) {
                    return 1;
                }

                if (a.TotalPrice < b.TotalPrice) {
                    return -1;
                }

                return 0;
            }

            if (res && res.MarhabaQuotes && res.MarhabaQuotes.length !== 0) {
                res.MarhabaQuotes.sort(_order).forEach(_categorize);
            } else {
                cm.noServices = true;
            }

            $rootScope.unlockScreen($scope);
        });

        cm.header.title = `${resourceService.get(trip.MarhabaRequest.FlightType === 1 ? 'ARRIVAL' : 'DEPARTURE')} `;
        cm.header.title += `${resourceService.get('SERVICEFOR')} `;
        cm.header.title += trip.MarhabaRequest.Terminal.Name;
        cm.header.subTitle = trip.MarhabaRequest.DateAndTime;

        cm.selectProduct = function selectProduct(productId) {
            let category = 'Marhaba';
            function getProductName() {

                const a = cm.lounges.concat(cm.meetGreet);
                let i = a.find(item => {
                    return item.Id === productId;
                });

                if (i === undefined) {
                    category = 'Transfers';
                    i = cm.transfers.find(item => {
                        return item.Id === productId;
                    });
                }

                return i.Name;
            }

            analytics.track('mixpanel', 'MarhabaPageClick', {
                ProductDescription: getProductName(),
                productCategory: category
            });

            $location.path(`marhaba/${$routeParams.tripId}/${productId}`);
        };
    });
}
})();
